/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppBoxesRouteImport } from './routes/_app/boxes'
import { Route as AppCurrenciesRouteImport } from './routes/_app/currencies'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppTreasuryRouteImport } from './routes/_app/treasury'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppSettingsExchangeRouteImport } from './routes/_app/settings/exchange'
import { Route as AppSettingsGroupsRouteImport } from './routes/_app/settings/groups'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups.index'
import { Route as AppSettingsGroupsIdRouteImport } from './routes/_app/settings/groups.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBoxesRoute = AppBoxesRouteImport.update({
  id: '/boxes',
  path: '/boxes',
  getParentRoute: () => AppRoute,
} as any)
const AppCurrenciesRoute = AppCurrenciesRouteImport.update({
  id: '/currencies',
  path: '/currencies',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppTreasuryRoute = AppTreasuryRouteImport.update({
  id: '/treasury',
  path: '/treasury',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsExchangeRoute = AppSettingsExchangeRouteImport.update({
  id: '/settings/exchange',
  path: '/settings/exchange',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsRoute = AppSettingsGroupsRouteImport.update({
  id: '/settings/groups',
  path: '/settings/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsGroupsRoute,
} as any)
const AppSettingsGroupsIdRoute = AppSettingsGroupsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSettingsGroupsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/boxes': typeof AppBoxesRoute
  '/currencies': typeof AppCurrenciesRoute
  '/reports': typeof AppReportsRoute
  '/treasury': typeof AppTreasuryRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/settings/exchange': typeof AppSettingsExchangeRoute
  '/settings/groups': typeof AppSettingsGroupsRouteWithChildren
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/groups/$id': typeof AppSettingsGroupsIdRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
}
export interface FileRoutesByTo {
  '/boxes': typeof AppBoxesRoute
  '/currencies': typeof AppCurrenciesRoute
  '/reports': typeof AppReportsRoute
  '/treasury': typeof AppTreasuryRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/settings/exchange': typeof AppSettingsExchangeRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/groups/$id': typeof AppSettingsGroupsIdRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/boxes': typeof AppBoxesRoute
  '/_app/currencies': typeof AppCurrenciesRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/treasury': typeof AppTreasuryRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settings/exchange': typeof AppSettingsExchangeRoute
  '/_app/settings/groups': typeof AppSettingsGroupsRouteWithChildren
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/settings/groups/$id': typeof AppSettingsGroupsIdRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/boxes'
    | '/currencies'
    | '/reports'
    | '/treasury'
    | '/auth/launch'
    | '/settings/exchange'
    | '/settings/groups'
    | '/settings/users'
    | '/settings/groups/$id'
    | '/settings/groups/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/boxes'
    | '/currencies'
    | '/reports'
    | '/treasury'
    | '/auth/launch'
    | '/'
    | '/settings/exchange'
    | '/settings/users'
    | '/settings/groups/$id'
    | '/settings/groups'
  id:
    | '__root__'
    | '/_app'
    | '/_app/boxes'
    | '/_app/currencies'
    | '/_app/reports'
    | '/_app/treasury'
    | '/auth/launch'
    | '/_app/'
    | '/_app/settings/exchange'
    | '/_app/settings/groups'
    | '/_app/settings/users'
    | '/_app/settings/groups/$id'
    | '/_app/settings/groups/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/boxes': {
      id: '/_app/boxes'
      path: '/boxes'
      fullPath: '/boxes'
      preLoaderRoute: typeof AppBoxesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/currencies': {
      id: '/_app/currencies'
      path: '/currencies'
      fullPath: '/currencies'
      preLoaderRoute: typeof AppCurrenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/treasury': {
      id: '/_app/treasury'
      path: '/treasury'
      fullPath: '/treasury'
      preLoaderRoute: typeof AppTreasuryRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/exchange': {
      id: '/_app/settings/exchange'
      path: '/settings/exchange'
      fullPath: '/settings/exchange'
      preLoaderRoute: typeof AppSettingsExchangeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups': {
      id: '/_app/settings/groups'
      path: '/settings/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof AppSettingsGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppSettingsGroupsRoute
    }
    '/_app/settings/groups/$id': {
      id: '/_app/settings/groups/$id'
      path: '/$id'
      fullPath: '/settings/groups/$id'
      preLoaderRoute: typeof AppSettingsGroupsIdRouteImport
      parentRoute: typeof AppSettingsGroupsRoute
    }
  }
}

interface AppSettingsGroupsRouteChildren {
  AppSettingsGroupsIdRoute: typeof AppSettingsGroupsIdRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
}

const AppSettingsGroupsRouteChildren: AppSettingsGroupsRouteChildren = {
  AppSettingsGroupsIdRoute: AppSettingsGroupsIdRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
}

const AppSettingsGroupsRouteWithChildren =
  AppSettingsGroupsRoute._addFileChildren(AppSettingsGroupsRouteChildren)

interface AppRouteChildren {
  AppBoxesRoute: typeof AppBoxesRoute
  AppCurrenciesRoute: typeof AppCurrenciesRoute
  AppReportsRoute: typeof AppReportsRoute
  AppTreasuryRoute: typeof AppTreasuryRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSettingsExchangeRoute: typeof AppSettingsExchangeRoute
  AppSettingsGroupsRoute: typeof AppSettingsGroupsRouteWithChildren
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBoxesRoute: AppBoxesRoute,
  AppCurrenciesRoute: AppCurrenciesRoute,
  AppReportsRoute: AppReportsRoute,
  AppTreasuryRoute: AppTreasuryRoute,
  AppIndexRoute: AppIndexRoute,
  AppSettingsExchangeRoute: AppSettingsExchangeRoute,
  AppSettingsGroupsRoute: AppSettingsGroupsRouteWithChildren,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
